/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Search results: show only products whose TITLE contains the search words (Shopify also matches product descriptions,
   so "cuptor" returned pots that say "can go in the oven"). Falls back to the normal results whenever it cannot help:
   model/SKU searches (a number in the query), searches no title matches (category or tag searches) and any error. */
(function () {
  try {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || '').trim();
    if (!q || q.indexOf(':') > -1) return;

    var norm = function (s) { return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
    var terms = norm(q).split(/[^a-z0-9]+/).filter(Boolean);
    if (!terms.length || terms.some(function (t) { return /\d/.test(t); })) return;
    var stems = terms.map(function (t) { return t.length <= 4 ? t : t.slice(0, Math.max(4, t.length - (t.length >= 7 ? 3 : 1))); });

    var matches = function (title) {
      var words = norm(title).split(/[^a-z0-9]+/);
      return stems.every(function (stem) { return words.some(function (w) { return w.indexOf(stem) === 0; }); });
    };


    var lastKnown = null, finding = false;
    var limitPages = function (last) {
      lastKnown = last;
      document.querySelectorAll('.pagination__nav-item').forEach(function (e) {
        var n = parseInt(e.textContent, 10);
        if (isNaN(n) || n > last) e.style.display = 'none';
      });
      document.querySelectorAll('.pagination__next').forEach(function (e) { if (parseInt(e.getAttribute('data-page'), 10) > last) e.style.display = 'none'; });
      document.querySelectorAll('.pagination__page-count').forEach(function (e) {
        var text = e.textContent.replace(/(\d+)(\D*)$/, last + '$2');
        if (text !== e.textContent) e.textContent = text;
      });
    };
    var findLastPage = function (page) {
      if (finding || lastKnown !== null) { if (lastKnown !== null) limitPages(lastKnown); return; }
      var pageCount = document.querySelector('.pagination__page-count');
      var total = pageCount ? parseInt((pageCount.textContent.match(/(\d+)\D*$/) || [])[1], 10) : 0;
      if (!total || page >= total) return;
      finding = true;
      var last = page;
      var next = function (p) {
        if (p > total) { limitPages(last); return; }
        var u = new URL(window.location.href); u.searchParams.set('page', String(p));
        fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var hit = Array.prototype.some.call(doc.querySelectorAll('.product-list--collection .product-item__title'), function (t) { return matches(t.textContent); });
          if (hit) { last = p; next(p + 1); } else { limitPages(last); }
        }).catch(function () { finding = false; });
      };
      next(page + 1);
    };

    var apply = function () {
      try {
        var items = document.querySelectorAll('.product-list--collection .product-item');
        if (!items.length) return;
        var ok = [], bad = [];
        items.forEach(function (item) {
          var t = item.querySelector('.product-item__title');
          (t && matches(t.textContent) ? ok : bad).push(item);
        });
        var page = parseInt(params.get('page') || '1', 10);
        if (!ok.length && page <= 1) return;
        ok.forEach(function (i) { i.style.display = ''; });
        bad.forEach(function (i) { i.style.display = 'none'; });
        document.querySelectorAll('.collection__showing-count').forEach(function (e) { e.style.display = 'none'; });
        if (bad.length) { limitPages(page); } else { findLastPage(page); }
        if (!ok.length && !document.querySelector('.search-title-filter-note')) {
          var list = document.querySelector('.product-list--collection');
          var hu = (document.documentElement.lang || '').indexOf('hu') === 0;
          var first = new URLSearchParams(window.location.search); first.delete('page');
          var note = document.createElement('p');
          note.className = 'search-title-filter-note';
          note.innerHTML = (hu ? 'Nincs több releváns találat. ' : 'Nu mai sunt rezultate relevante. ') +
            '<a href="' + window.location.pathname + '?' + first.toString() + '">' + (hu ? 'Vissza az első oldalra' : 'Înapoi la prima pagină') + '</a>';
          list.parentNode.insertBefore(note, list.nextSibling);
        }
      } catch (e) {}
    };

    var timer;
    var run = function () { clearTimeout(timer); timer = setTimeout(apply, 80); };
    document.addEventListener('DOMContentLoaded', run);
    window.addEventListener('load', run);
    new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
    run();
  } catch (e) {}
})();

/* Prices: the decimals (46,38 Lei -> "38") are shown smaller and aligned to the top. Wraps the digits in .price-dec for
   every .price, also after the theme re-renders prices (variant change, mini-cart). Does nothing on any error. */
(function () {
  try {
    var style = document.createElement('style');
    style.textContent = '.price-dec{font-size:.6em;vertical-align:top;position:relative;top:.12em;margin-left:.05em;line-height:1}.price:not(.price--compare){font-weight:600}.price--compare{font-weight:400}';
    document.head.appendChild(style);

    var re = /(\d)([,.])(\d{2})(?!\d)/;
    var wrap = function (root) {
      var scope = root.nodeType === 1 ? root : root.parentElement;
      if (!scope) return;
      var list = scope.matches && scope.matches('.price') ? [scope] : [];
      if (scope.querySelectorAll) list = list.concat([].slice.call(scope.querySelectorAll('.price')));
      var p = scope.closest ? scope.closest('.price') : null;
      if (p && list.indexOf(p) === -1) list.push(p);
      list.forEach(function (el) {
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var nodes = [], n;
        while ((n = walker.nextNode())) {
          if (n.parentElement.closest('.price-dec, .visually-hidden')) continue;
          if (re.test(n.nodeValue)) nodes.push(n);
        }
        nodes.forEach(function (t) {
          var m = re.exec(t.nodeValue);
          if (!m) return;
          var cut = m.index + 1 + m[2].length; // right after the separator
          var rest = t.splitText(cut);
          var dec = rest.splitText(2);
          var span = document.createElement('span');
          span.className = 'price-dec';
          span.textContent = rest.nodeValue;
          rest.parentNode.replaceChild(span, rest);
          void dec;
        });
      });
    };

    wrap(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (mu) {
        mu.addedNodes.forEach(function (nd) { if (nd.nodeType === 1 || nd.nodeType === 3) wrap(nd); });
        if (mu.type === 'characterData') wrap(mu.target);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  } catch (e) { /* prices stay as they are */ }
})();

/* Wallet line on the product page: "+12,60 Lei in wallet" = 5% of the price, times the chosen quantity, shown under the
   price. ON for efabrik.ro since 2026-11-01 and efabrik.hu (HUF) since 2026-11-02 (user); set WALLET_ON to false to hide it. */
(function () {
  var WALLET_ON = true, PERCENT = 5;
  try {
    if (!WALLET_ON) return;
    var lang = (document.documentElement.lang || 'ro').slice(0, 2).toLowerCase();
    var label = lang === 'hu' ? 'a pénztárcádban' : 'în portofel';

    var parse = function (text) {
      var m = /(\d[\d.,\s  ]*)/.exec(text);
      if (!m) return null;
      var raw = m[1].replace(/[\s  ]/g, '');
      var dec = /^(.*)[,.](\d{2})$/.exec(raw);
      var num = dec ? parseFloat(dec[1].replace(/[.,]/g, '') + '.' + dec[2]) : parseFloat(raw.replace(/[.,]/g, ''));
      var suffix = text.slice(m.index + m[1].length).replace(/\s+/g, ' ').trim();
      return isNaN(num) ? null : { num: num, decimals: !!dec, suffix: suffix };
    };
    var format = function (value, decimals) {
      if (decimals) return value.toFixed(2).replace('.', ',');
      return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    var render = function () {
      document.querySelectorAll('.product-form__info-list').forEach(function (list) {
        var items = list.querySelectorAll('.product-form__info-item');
        var item = items[0]; // the Pret row (first row of the form)
        var priceEl = list.querySelector('.price:not(.price--compare)');
        var form = list.closest('form') || document;
        var qtyEl = form.querySelector('input[name="quantity"]');
        var p = priceEl && parse(priceEl.textContent.replace(/^\s*[^\d]*(?=\d)/, ''));
        var line = list.querySelector('.wallet-line');
        if (!item || !p) { if (line) line.parentNode.remove(); return; }
        var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var amount = format(p.num * PERCENT / 100 * qty, p.decimals);
        p.suffix = p.suffix.replace(/^Lei$/, 'lei'); // the wallet line writes lei in lowercase
        var text = '+' + amount + (p.suffix ? ' ' + p.suffix : '') + ' ' + label;
        if (!line) {
          line = document.createElement('a'); // links to the wallet explanation page
          line.href = lang === 'hu' ? '/pages/penztarca' : '/pages/portofel';
          line.className = 'wallet-line';
          var cell = document.createElement('span'); // its own table cell in the Cantitate row, to the right of the quantity box
          cell.className = 'wallet-cell';
          cell.appendChild(line);
          item.appendChild(cell);
        }
        if (line.getAttribute('data-text') !== text) {
          line.setAttribute('data-text', text);
          line.textContent = '';
          var parts = p.decimals ? /^(.*[,.])(\d{2})$/.exec(amount) : null;
          if (parts) {
            var dec = document.createElement('span');
            dec.className = 'wallet-dec';
            dec.textContent = parts[2];
            line.appendChild(document.createTextNode('+' + parts[1]));
            line.appendChild(dec);
            line.appendChild(document.createTextNode((p.suffix ? ' ' + p.suffix : '') + ' ' + label));
          } else line.textContent = text;
        }
      });
    };

    var style = document.createElement('style');
    style.textContent = '.wallet-dec{font-size:.55em;vertical-align:baseline;position:relative;top:-.62em;margin-left:.06em;line-height:0}.wallet-cell{display:table-cell;width:100%;vertical-align:middle;padding:0 0 0 .9em}.product-form__info-item:has(.wallet-cell) > .product-form__info-content{width:1%;white-space:nowrap}a.wallet-line,a.wallet-line:hover{text-decoration:none}.wallet-line{font-size:calc(1em + 2px);padding:.1em .6em;border:1px solid #1e9e4a;border-radius:6px;font-weight:700;color:#1e9e4a;display:inline-block;box-sizing:border-box;white-space:nowrap}@media(max-width:749px){.wallet-cell{padding-left:.5em}.wallet-line{padding:.1em .4em;font-size:13px}}@media(max-width:380px){.wallet-cell{padding-left:.35em}.wallet-line{padding:.1em .3em;font-size:12px}}';
    document.head.appendChild(style);

    var queued = false;
    var queue = function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; render(); }); };
    ['input', 'change', 'click'].forEach(function (ev) { document.addEventListener(ev, queue, true); });
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
    render();
  } catch (e) { /* no wallet line */ }
})();
